<template>
    <v-layout
        class="fill-height"
    >
        <v-navigation-drawer
            class="filter-navigation pt-16"
            :permanent="!$vuetify.breakpoint.smAndDown"
            :absolute="$vuetify.breakpoint.smAndDown"
            v-model="filterDrawer"
            width="300"
        >
            <form
                class="pa-4"
            >
                <v-text-field
                    name="search"
                    v-model="filter.search"
                    :label="$t('bookings.filter.search')"
                    :placeholder="$t('bookings.placeholder.search')"
                    append-icon="mdi-magnify"
                />
                <v-menu
                    v-model="menus.createdFrom"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template
                        v-slot:activator="{ on, attrs }"
                    >
                        <v-text-field
                            v-model="filter.createdFrom"
                            :label="$t('bookings.filter.createdFrom')"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        />
                    </template>
                    <v-date-picker
                        v-model="filter.createdFrom"
                        @input="menus.createdFrom = false"
                    />
                </v-menu>
                <v-menu
                    v-model="menus.createdTo"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template
                        v-slot:activator="{ on, attrs }"
                    >
                        <v-text-field
                            v-model="filter.createdTo"
                            :label="$t('bookings.filter.createdTo')"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        />
                    </template>
                    <v-date-picker
                        v-model="filter.createdTo"
                        @input="menus.createdTo = false"
                    />
                </v-menu>
                <v-menu
                    v-model="menus.departureFrom"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template
                        v-slot:activator="{ on, attrs }"
                    >
                        <v-text-field
                            v-model="filter.departureFrom"
                            :label="$t('bookings.filter.arrivalFrom')"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        />
                    </template>
                    <v-date-picker
                        v-model="filter.departureFrom"
                        @input="menus.departureFrom = false"
                    />
                </v-menu>
                <v-menu
                    v-model="menus.departureTo"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template
                        v-slot:activator="{ on, attrs }"
                    >
                        <v-text-field
                            v-model="filter.departureTo"
                            :label="$t('bookings.filter.arrivalTo')"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        />
                    </template>
                    <v-date-picker
                        v-model="filter.departureTo"
                        @input="menus.departureTo = false"
                    />
                </v-menu>
                <v-btn
                    @click="resetFilter"
                >
                    {{ $t('action.reset') }}
                </v-btn>
            </form>
        </v-navigation-drawer>
        <v-container
            fluid
            class="pt-16"
        >
            <v-row>
                <v-col
                    cols="12"
                >
                    <v-btn
                        @click="filterDrawer = !filterDrawer"
                        class="d-block d-md-none"
                    >
                        Filter
                    </v-btn>
                    <h1>
                        {{ total }} {{ $tc('bookings.headline.booking', total) }}
                    </h1>
                    <v-divider/>
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    cols="12"
                >
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :loading="isLoading || saving"
                        :server-items-length="total"
                        :options.sync="options"
                        :footer-props="{ itemsPerPageOptions: [10, 15, 30] }"
                    >
                        <template
                            v-slot:item._status="{ item }"
                        >
                            <rula-status
                                v-if="!isNoRula"
                                :item="item"
                            />
                        </template>
                        <template
                            v-slot:item.booking_date="{ item }"
                        >
                            {{ new Date(item.booking_date).toLocaleDateString() }}
                        </template>
                        <template
                            v-slot:item.tour_start="{ item }"
                        >
                            {{ new Date(item.tour_start).toLocaleDateString() }}
                        </template>
                        <template
                            v-slot:item.customer_surname="{ item }"
                        >
                            {{ item.customer_surname }}
                        </template>
                        <template
                            v-slot:item.booking_price="{ item }"
                        >
                            {{ item.booking_price | price }}
                        </template>
                        <template
                            v-slot:item.actions="{ item }"
                        >
                            <v-btn
                                icon
                                v-if="!isNoRula"
                                :title="$t('bookings.action.uploadRula')"
                                @click="uploadMaterials(item)"
                            >
                                <v-icon>
                                    mdi-file-multiple
                                </v-icon>
                            </v-btn>
                            <v-btn
                                icon
                                v-role:admin
                                v-if="!isNoRula && (!item._meta || !item._meta.rulaReleased)"
                                :title="$t('bookings.action.remindRula')"
                                @click="remindRula(item)"
                            >
                                <v-icon>
                                    mdi-message-alert
                                </v-icon>
                            </v-btn>
                            <v-btn
                                icon
                                v-role:admin
                                v-if="!isNoRula && (!item._meta || !item._meta.rulaReleased)"
                                :title="$t('bookings.action.confirmRula')"
                                @click="confirmRula(item)"
                            >
                                <v-icon>
                                    mdi-check
                                </v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <rula-upload-form
                v-model="modalActive"
                :booking="activeItem"
                @comment="handleComment"
            />
            <confirm-dialog
                ref="confirmDialog"
            />
            <confirm-dialog
                ref="reminderDialog"
            >
                <v-row>
                    <v-col>
                        <v-textarea
                            :label="$t('rula.label.remindMessage')"
                            v-model="reminder.message"
                            rows="10"
                        />
                    </v-col>
                </v-row>
            </confirm-dialog>
        </v-container>
    </v-layout>
</template>

<script>
    import '@/filter/number';
    import '@/filter/price';
    import '@/filter/time';
    import { mapActions, mapGetters } from "vuex";
    import { BookingsActions } from "@/store/bookings/types";
    import { debounce } from "debounce";
    import RulaUploadForm from "@/components/Booking/RulaUploadForm";
    import RulaStatus from "@/components/Rula/RulaStatus";
    import ConfirmDialog from "@/components/Dialog/ConfirmDialog";
    import axios from "axios";
    import {SnackBarAction, SnackBarTypes} from "@/store/snackbar/types";
    import {getMissingCategories} from "@/utils/rula";

    export default {
        components: {
            ConfirmDialog,
            RulaStatus,
            RulaUploadForm,
        },
        mounted() {
            this.loadBookingsDebounce = debounce(this.loadBookings, 500);
        },
        data: () => ({
            filter: {
                search: null,
                createdFrom: null,
                createdTo: null,
                departureFrom: new Date().toISOString().slice(0, 10),
                departureTo: null,
            },
            menus: {
                createdFrom: false,
                createdTo: false,
                departureFrom: false,
                departureTo: false,
            },
            filterDrawer: false,
            options: {
                sortBy: ['tour_start'],
                sortDesc: [false],
                page: 1,
                itemsPerPage: 10,
            },
            activeItem: {
                _meta: {
                    rulaReleased: false,
                    documents: [],
                },
            },
            modalActive: false,
            saving: false,
            reminder: {
                message: '',
                item: null,
            },
        }),
        computed: {
            ...mapGetters({
                items: 'bookings/bookings',
                isAdmin: 'auth/isAdmin',
                total: 'bookings/totalBookings',
                isLoading: 'bookings/isLoading',
                isNoRula: 'auth/isNoRula',
            }),
            headers() {
                return [
                    {
                        text: this.$t('bookings.headers.status'),
                        value: '_status',
                    },
                    {
                        text: this.$t('bookings.headers.bookingNo'),
                        value: 'booking_no',
                    },
                    {
                        text: this.$t('bookings.headers.name'),
                        value: 'customer_surname',
                        sortable: false,
                    },
                    {
                        text: this.$t('bookings.headers.guests'),
                        value: 'booking_pax',
                        sortable: false,
                    },
                    {
                        text: this.$t('bookings.headers.tourCode'),
                        value: 'tour_code',
                    },
                    {
                        text: this.$t('bookings.headers.tourName'),
                        value: 'tour_title',
                        width: 250,
                        sortable: false,
                    },
                    {
                        text: this.$t('bookings.headers.arrival'),
                        value: 'tour_start',
                    },
                    {
                        text: this.$t('bookings.headers.totalPrice'),
                        value: 'booking_price',
                        sortable: false,
                    },
                    {
                        text: this.$t('bookings.headers.bookingDate'),
                        value: 'booking_date',
                    },
                    {
                        text: this.$t('headers.actions'),
                        value: 'actions',
                        sortable: false,
                    },
                ];
            },
        },
        watch: {
            options: {
                handler() {
                    this.loadBookings();
                },
                deep: true,
            },
            filter: {
                handler() {
                    this.loadBookingsDebounce();
                },
                deep: true,
            },
            modalActive(newValue) {
                if(
                    newValue === false
                ) {
                    this.loadBookings();
                }
            }
        },
        methods: {
            ...mapActions({
                load: `bookings/${BookingsActions.LOAD_BOOKINGS}`,
                setSnackbar: `snackbar/${SnackBarAction.SET}`,
            }),
            getMissingCategories,
            resetFilter() {
                this.filter = {
                    search: null,
                    createdFrom: null,
                    createdTo: null,
                    departureFrom: new Date().toISOString().slice(0, 10),
                    departureTo: null,
                };
            },
            loadBookings() {
                this.load({
                    options: this.options,
                    filter: this.filter,
                });
            },
            uploadMaterials(item) {
                this.activeItem = item;
                this.modalActive = true;
            },
            async confirmRula(item) {
                if(
                    await this.$refs.confirmDialog.open(
                        this.$t('rula.confirm'),
                        this.$t('rula.confirmQuestion', {
                            id: item.booking_no,
                        })
                    )
                ) {
                    this.saving = true;

                    axios
                        .put(`/booking/${item.booking_no}/rula/confirm`)
                        .then(() => {
                            if(!item._meta) {
                                item._meta = {
                                    rulaReleased: true,
                                    documents: [],
                                }
                            } else {
                                item._meta.rulaReleased = true;
                            }

                            this.setSnackbar({
                                data: this.$t('rula.snackbar.releaseSuccess'),
                                type: SnackBarTypes.SUCCESS
                            });
                        })
                        .catch(err => {
                            this.setSnackbar({
                                data: this.$t('rula.snackbar.releaseError'),
                                type: SnackBarTypes.ERROR
                            });
                            console.error(err);
                        })
                        .finally(() => {
                            this.saving = false;
                        });
                }
            },
            async remindRula(item) {
                this.reminder.item = Object.assign(
                    {},
                    item
                );
                this.reminder.message = this.$t('rula.remindMessage', 'de', {
                    name: item.customer_surname,
                    start: new Date(item.tour_start).toLocaleDateString(),
                    tourName: item.tour_title,
                    categories: getMissingCategories(item._meta).map((category) => {
                        return '* ' + this.$t(`rula.category.${category}`);
                    }).join('\r\n'),
                });

                this.reminder.message += '\r\n\r\n';

                this.reminder.message = this.$t('rula.remindMessage', {
                    name: item.customer_surname,
                    start: new Date(item.tour_start).toLocaleDateString(),
                    tourName: item.tour_title,
                    categories: getMissingCategories(item._meta).map((category) => {
                        return '* ' + this.$t(`rula.category.${category}`);
                    }).join('\r\n'),
                });

                if(
                    await this.$refs.reminderDialog.open(
                        this.$t('rula.remind'),
                        this.$t('rula.remindQuestion', {
                            id: item.booking_no,
                        }),
                        {
                            width: 600,
                        },
                    )
                ) {
                    this.saving = true;

                    let payload = Object.assign(
                        this.reminder,
                        {
                            categories: getMissingCategories(item._meta),
                        },
                    );

                    axios
                        .post(
                            `/booking/${item.booking_no}/rula/remind`,
                            payload
                        )
                        .then(resp => {
                            return resp.data;
                        })
                        .then(data => {
                            this.setSnackbar({
                                data: this.$t('rula.snackbar.remindSuccess', {email: data.email}),
                                type: SnackBarTypes.SUCCESS
                            });

                            // Reset model
                            this.reminder = {
                                categories: [],
                                message: '',
                                item: null,
                            };
                        })
                        .catch(err => {
                            this.setSnackbar({
                                data: this.$t('rula.snackbar.remindError'),
                                type: SnackBarTypes.ERROR
                            });
                            console.error(err);
                        })
                        .finally(() => {
                            this.saving = false;
                        });
                }
            },
            handleComment(comment){
                if(!this.activeItem._meta){
                    this.activeItem._meta = {
                        comment: comment,
                        rulaReleased: true,
                        documents: [],
                    }
                }else{
                    this.activeItem._meta.comment = comment;
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .filter-navigation {
        background-color: #F3F3F3;
    }

    .theme--light.v-chip {
        color: white;
    }

    .booking-number-text {
        width: 80px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: inline-block;
    }
</style>
